<template>
    <div>

    </div>
</template>

<script>
    import {mapActions,mapState} from 'vuex'
    import labApi from '@/api/lab/agent.js'
    import axios from 'axios'
    import moment from 'moment'
    import cookie from "vue-cookies";

    export default {
        name: "mixins",
        data() {
            return {
                expiredIn:0,
                loadStatus:'n',
                errorModal: false,
                errorMsg: '',
                lab_id: ''||sessionStorage.getItem("lab_id"),
                lab_url: '',
                end_time: '',
                status: 5000000,
                vnc_url: '',
                percent: 0,
                progressTxt: '',
                access_token: cookie.get('session')

            }
        },
        computed:{
            ...mapState({
                del_lab_id: state => state.lab.del_lab_id,
            })
        },
        methods: {
            ...mapActions({
                deleteLab: 'lab/deleteLab',
            }),
            errorOk() {
                sessionStorage.clear();
                this.$parent.$parent.currentView = '';
                this.$parent.$parent.isEnvShow = true
            },
            apiErrModal(msg) {
                let _this = this
                this.$Modal.error({
                    title: '请求错误',
                    content: msg,
                    onOk: () => {
                        _this.errorOk()
                    },
                });
            },
            beforeunloadHandler() {
                this._beforeUnload_time = new Date().getTime();
            },
            //浏览器关闭删除容器
            unloadHandler(e) {
                let _this = this;
                this._gap_time = new Date().getTime() - this._beforeUnload_time;
                //判断是窗口关闭还是刷新
                if (this._gap_time <= 10) {
                    let t_id = parseInt(sessionStorage.getItem("lab_id"));
                    localStorage.setItem('close', new Date().getTime() + "_" + t_id);
                    this.labDelete(t_id);
                }
            },
            //删除容器
            labDelete(labId) {
                let _this = this;
                _this.deleteLab({
                    data:{
                        "url":_this.domain_name,
                        "lab_id":labId
                    },
                    labIdKey:'lab_id'
                });
            },
            //创建容器
            getLabApply(subsec_id) {
                let _this = this;
                labApi.labApply(_this.domain_name, {
                    "subsec_id": subsec_id,
                }).then(res => {
                    if (res.data.status.code == 2000000) {
                        this.percent += Math.floor(Math.random() * 10) + 1;
                        this.progressTxt = '请求中';
                        _this.lab_id = (res.data.body.lab_id).toString();
                        sessionStorage.setItem("lab_id", res.data.body.lab_id);

                        this.getLabQuery(subsec_id)
                    } else {
                        _this.apiErrModal(res.data.status.message)
                    }
                }).catch(err => {
                    if (err) {
                        this.apiErrModal('请求异常，请稍后再试！')
                    }

                })
            },
            //查询容器
            getLabQuery() {
                let _this = this;
                let labId = '';
                labId = sessionStorage.getItem('lab_id');

                let timer = setTimeout(() => {
                    console.log("del_lab_id:"+this.$store.state.lab.del_lab_id + "---labId:"+labId);
                    if(this.$store.state.lab.del_lab_id >= labId || labId == null){
                        clearTimeout();
                        return;
                    }
                    labApi.labQuery(_this.domain_name,{"lab_id": labId}).then(res => {
                        let data = res.data;
                        if (data.status.code == 2000000) {
                            _this.percent = 95;
                            _this.progressTxt = '创建中';
                            let formatDate = moment(data.body.end_at).format('YYYY/MM/DD HH:mm:ss');
                            let nowTime = new Date().getTime();
                            let endTime = new Date(nowTime + 2000 * 60).getTime();
                            _this.expiredIn = data.body.expired_in;
                            _this.end_time = formatDate;
                            _this.checkUrl(`${data.body.address}`, endTime, 'lab_id');
                            sessionStorage.setItem("endTime", data.body.end_at);
                            clearTimeout(timer)
                        } else {
                            if (data.status.code == 5000108) {
                                _this.errorModal = true;
                                _this.errorMsg = data.status.message;
                                clearTimeout(timer)
                            } else if (data.status.code == 5000111) {
                                if (_this.percent > 90) {
                                    _this.percent = 95
                                } else {
                                    _this.percent += Math.floor(Math.random() * 10) + 1
                                }
                                _this.progressTxt = '审核中';
                                _this.getLabQuery()
                            } else {
                                _this.apiErrModal(data.status.message);
                                clearTimeout(timer)
                            }
                        }

                    }).catch(err => {
                        if (err) {
                            _this.apiErrModal('请求异常，请稍后再试！');
                            clearTimeout(timer)
                        }

                    })
                }, 2000);
            },
            checkUrl(url, endTime, sessionIdKey) {
                let _this = this;
                let checkUrlTimer = setTimeout(function () {
                    _this.percent = 100;
                    _this.progressTxt = '启动中';
                    let nowTime = new Date().getTime();
                    let t = endTime - nowTime;
                    if (t > 0) {
                        axios.get(url).then(res => {
                            let data = res.data;
                            if (data.code !== 500) {
                                _this.lab_url = url;
                                clearTimeout(checkUrlTimer)
                            }
                        }).catch(function (error) {
                            _this.checkUrl(url, endTime, sessionIdKey)
                        });
                    } else {
                        _this.labDelete(_this.lab_id);
                        sessionStorage.removeItem(sessionIdKey);
                        clearTimeout(checkUrlTimer)
                    }
                }, 3000);
            },
            heartbeatInterval(lab_id){
                let _this = this;
                console.log("心跳~~~~");
                console.log("del_lab_id_default"+_this.del_lab_id);
                if(lab_id){
                    let fixedTime = (new Date()).getTime();
                    let timer = setInterval(function(){
                        let nowTime = new Date();
                        // let endTime = new Date(_this.end_time);
                        let t = (fixedTime + (_this.expiredIn * 1000)) - nowTime.getTime();
                        if(_this.end_time && lab_id > _this.$store.state.lab.del_lab_id ){
                            if (t > 0) {
                                console.log("砰~");
                                labApi.labHeartbeat(_this.domain_name,{"lab_id": lab_id}).then(data => {
                                    if(data.data.status.code != 2000000){
                                        sessionStorage.removeItem('lab_id');
                                        sessionStorage.removeItem("lab_type");
                                        sessionStorage.removeItem("img_type");
                                        if(data.data.status.code != 5000108) {
                                            _this.$Modal.error({
                                                title: '请求错误',
                                                content: data.data.status.message,
                                                onOk: () => {
                                                    _this.$parent.$parent.currentView = '';
                                                    _this.$parent.$parent.isEnvShow = true
                                                },
                                            });
                                        }
                                        clearInterval(timer);
                                    }
                                }).catch(function (error) {
                                    // clearInterval(timer);
                                });
                            } else {
                                sessionStorage.removeItem('lab_id');
                                _this.envModal = true;
                                clearInterval(timer);
                            }
                        }
                    },10000)

                }
            },
            ok() {
                window.location.reload()
            }
        },
        mounted() {
            window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
            window.addEventListener('unload', e => this.unloadHandler(e));
        },
        destroyed() {
            window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
            window.removeEventListener('unload', e => this.unloadHandler(e))
        },
        watch: {}
    }
</script>

<style scoped>

</style>
